import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription } from 'rxjs';
import { first, switchMap, take, takeUntil } from 'rxjs/operators';
import { AuthenticationService } from '../../../_common/_service/authentication.service';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';

import { KycComponent } from '../kyc/kyc.component';
import { OtpverificationComponent } from '../otpverification/otpverification.component';
import { DatePipe } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { CommonService } from '../../../_common/_service/user.service';


@Component({
  selector: 'app-add-merchantstore',
  templateUrl: './add-merchantstore.component.html',
  styleUrls: ['./add-merchantstore.component.scss']
})

export class AddmerchantstoreComponent implements OnInit {
  currentDate = new Date();
  loadingspinner: boolean = false;
  submitted = false;


  currentUser: any;
  public CountryFilterCtrl: FormControl = new FormControl();
  protected _onDestroy = new Subject<void>();
  countryList: any;
  xstoreName: any;
  public StoreForm: FormGroup;
    

  constructor(private fb: FormBuilder, private toastr: ToastrService, private tokenStorageService: TokenStorageService, public dialog: MatDialog,
    private authService: AuthService, public dialogRef: MatDialogRef<AddmerchantstoreComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  
    this.StoreForm = this.fb.group({
      StoreCountryid: [null, [Validators.required]],
      storeName: [null, [Validators.required]],
      storeAddress: [null, [Validators.required]],
      storeCity: [null, [Validators.required]],
      description: [null, [Validators.required]]
    })
  }


  ngOnInit() {


  
    this.currentUser = this.tokenStorageService.getUser();

    // listen for search field value changes
    this.getCountryCode();
    this.CountryFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterCountry();
      });
  }

  get f() { return this.StoreForm.controls; }



  getCountryCode() {

    this.submitted = true;
    this.authService.getOtpIsdCode().subscribe((response: { isSuccess: any; result: any; Message: any; }) => {

      this.countryList = response;

    }, (err: any) => {
      this.toastr.error(err.error, 'Error');
    }
    );
  }

  filterCountry() {

    if (this.CountryFilterCtrl.value) {

      return this.countryList.filter((x: { name: string; }) => x.name.toLowerCase().startsWith(this.CountryFilterCtrl.value.toLowerCase()));
    } else {
      return this.countryList;
    }
  }
  
  addmerchantstore(post: any) {

    this.submitted = true;

    if (this.StoreForm.valid) {
      this.loadingspinner = true;

      this.authService.addmerchantstore(post).subscribe((response: { apiStatus: any; apiMessage: any; }) => {
        this.loadingspinner = false;
        if (response.apiStatus == true) {

          this.toastr.success(response.apiMessage, 'Success');
          this.dialogRef.close();

        } else {
          this.toastr.error(response.apiMessage, "Error");
        }

      }, (err: any) => {
        this.loadingspinner = false;
        if (err.error instanceof Error) {

          this.toastr.error(err.error, 'Error');
        } else {

          this.toastr.error(err.error, 'Error');
        }
      }
      );
    }
  }

 
}

